import { useAppointmentFromContext } from 'pages/Appointment';
import { findMemberIdFromAppointment } from 'pages/Appointment/hooks/useAppointment';
import { useMember } from 'shared/hooks';
export var useMemberForAppointment = function () {
    var appointment = useAppointmentFromContext();
    var memberId = findMemberIdFromAppointment(appointment);
    var useMemberResult = useMember(memberId !== null && memberId !== void 0 ? memberId : '');
    return useMemberResult;
};
